// React import
import * as React from "react";
// Standard layout imports
import { Columns, Column } from "src/components/Layout/Grid";
import Button from "src/components/Button";
import { IActivityModel } from "src/Entities/Activity/Activity";
import Icon from "src/components/Icon";
import { ActivitySelector } from "src/Entities/Activity/Activity.Selector";
import { Link } from "react-router-dom";
import Tag from "src/components/Tag";
import { format, compareAsc } from "date-fns";

interface ICategoryActivitiesProps {
  categoryId: number;
  themeId: number;
  onSelectActivity: (
    detailKursuId: string,
    themeId: string,
    categoryId: string
  ) => void;
}

interface ICategoryActivitiesState {
  activities: IActivityModel[];
  orderedBy: string;
  isAcsending: boolean

}

class CategoryActivitiesComponent extends React.Component<
  ICategoryActivitiesProps,
  ICategoryActivitiesState
> {
  constructor(props: ICategoryActivitiesProps) {
    super(props);

    this.state = {
      activities: ActivitySelector.getActivitiesByCategoryId(
        this.props.categoryId
      ).sort((a, b) => compareAsc(new Date(a.startDate), new Date(b.startDate))),
      orderedBy: "date",
      isAcsending: true,
    };

    this.renderActivity = this.renderActivity.bind(this);
    this.orderActivitiesBy = this.orderActivitiesBy.bind(this);
  }

  public getActivityURL(activity: IActivityModel): string {
    const { themeId, categoryId } = this.props;
    const { fiuNo } = activity;

    return `/kurser/${themeId}/${categoryId}/${fiuNo}`;
  }

  public orderActivitiesBy(OrderByType: string) {
    switch (OrderByType) {
      case "titel":
      if(this.state.orderedBy === "titel"){
        this.setState(
          Object.assign(this.state, {
            activities: this.state.activities.reverse(),
            orderedBy: "titel",
            isAcsending: !this.state.isAcsending,
          })
        );

      }else{
        this.setState(
          Object.assign(this.state, {
            activities: ActivitySelector.getActivitiesByCategoryId(
              this.props.categoryId
            ).sort((a, b) => (a.courseTitle.toLocaleLowerCase() > b.courseTitle.toLocaleLowerCase() ? 1 : -1)),
            orderedBy: "titel",
            isAcsending: true
          })
        );
        }
        break;
      case "date":
        if (this.state.orderedBy === "date") {
          this.setState(
            Object.assign(this.state, {
              activities: this.state.activities.reverse(),
              orderedBy: "date",
              isAcsending: !this.state.isAcsending,
            })
          );
        } else {
          this.setState(
            Object.assign(this.state, {
              activities: ActivitySelector.getActivitiesByCategoryId(
                this.props.categoryId
              ).sort((a, b) => compareAsc(new Date(a.startDate), new Date(b.startDate))),
              orderedBy: "date",
              isAcsending: true,
            })
          );
        }
        break;
    }
  }

  public renderHeader() {
    return (
      <Columns className="py1" gutter="default">
        <Column md={2}>
          <div className="flex items-center" style={{cursor: "pointer"}} onClick={() => this.orderActivitiesBy("titel")}>
            Titel
            {this.state.orderedBy === "titel" ? (
              <Icon
                size={15}
                name={this.state.isAcsending ? "chevron-down" : "chevron-up"}
                className="ml1"
              />
            ) : null}
          </div>
        </Column>
        <Column md="fill">
        <div>{" "}</div>
        </Column>
        <Column md={2}>
          <div className="flex items-center" style={{ cursor: "pointer"}} onClick={() => this.orderActivitiesBy("date")}>
            Dato
            {this.state.orderedBy === "date" ? (
              <Icon
                size={15}
                name={this.state.isAcsending ? "chevron-down" : "chevron-up"}
                className="ml1"
              />
            ) : null}
          </div>
        </Column>
      </Columns>
    );
  }

  public renderActivity(activity: IActivityModel) {
    const { tag } = activity;

    return (
      <div
        onClick={() =>
          this.props.onSelectActivity(
            activity.detailKursusId.toString(),
            this.props.themeId.toString(),
            this.props.categoryId.toString()
          )
        }
        className="link db"
        style={{ marginBottom: 3, cursor: "pointer" }}
        key={activity.detailKursusId}
      >
        <Columns
          alignItems="center"
          gutter="default"
          className="has-background-white"
        >
          <Column md="fill" className="fw6 py1">
            {activity.courseTitle}
          </Column>
          <Column md="auto">
            {tag && <Tag color={tag.color}>{tag.children}</Tag>}
          </Column>
          <Column md={2} className="fw6 py1">
            <div className="flex items-center">
              {activity.isAdvertisement ? <span className="f6 flex-auto justify"/> : <span className="f6 flex-auto">
                {format(new Date(activity.startDate), "dd.MM.yyyy")}
              </span> }
              <Button rounded={true} color="gray" size="micro">
                <Icon name="chevron-right" />
              </Button>
            </div>
          </Column>
        </Columns>
      </div>
    );
  }

  public render() {
    const { activities } = this.state;

    return (
      <div className="f5">
        {this.renderHeader()}
        {activities.map(this.renderActivity)}
      </div>
    );
  }
}

export default CategoryActivitiesComponent;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Activityies/categoryActivities.component.tsx